module.exports = __webpack_public_path__ + "static/media/NU.ff1b3c98.png";